<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Introduction: Why a Book on Praying for Missionaries?</a></div>
<div class="SOM_chap"><a href="#/chap1"><span class="mev1">1</span> Pray for More Workers to Finish the Mission</a></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample"><span class="mev1">2</span> Pray for Intimacy with God</span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample"><span class="mev1">3</span> Pray for Spiritual Coverage</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample"><span class="mev1">4</span> Pray for Strong Singles, Marriages, and Families</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample"><span class="mev1">5</span> Pray for Incarnational Love for the Nations</span></div>
<div class="SOM_chap"><span href="#/chap6" title="Link target outside of Sample"><span class="mev1">6</span> Pray for Oneness in the Teams</span></div>
<div class="SOM_chap"><span href="#/chap7" title="Link target outside of Sample"><span class="mev1">7</span> Pray for Never-Ending Devotion</span></div>
<div class="SOM_chap"><span href="#/chap8" title="Link target outside of Sample"><span class="mev1">8</span> Pray for Successful Ministry in the Eyes of God</span></div>
<div class="SOM_chap"><span href="#/chap9" title="Link target outside of Sample"><span class="mev1">9</span> Pray for Churches to Partner Well</span></div>
<div class="SOM_chap"><span href="#/chap10" title="Link target outside of Sample"><span class="mev1">10</span> Pray for Agencies to Partner Well</span></div>
<div class="SOM_chap"><span href="#/chap11" title="Link target outside of Sample"><span class="mev1">11</span> Pray for Reentering Well</span></div>
<div class="SOM_chap"><span href="#/chap12" title="Link target outside of Sample"><span class="mev1">12</span> Pray to End Well</span></div>
<div class="SOM_appen"><span href="#/appen3" title="Link target outside of Sample">Epilogue: Let’s Finish the Mission and Go Home</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Acknowledgments</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Praise for <i>Praying for Your Missionary</i></span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Also by Eddie Byun</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?678f6762